import styled from 'styled-components';
import { Body2, Heading6 } from '@estee/elc-typography';
import { ContentSpacing, breakpoint } from '@estee/elc-base-theme';
import { Button } from '@estee/elc-buttons';

import { defaultCTA, inheritBaseFont, StyledFooter } from '~theme/default-theme';

export const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: flex-start;
    justify-content: center;
`;

export const EmptyCartContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    min-width: 380px;
    min-height: 112px;
    padding: ${ContentSpacing.space32} ${ContentSpacing.space16} 0 ${ContentSpacing.space16};
`;

export const TitleLabel = styled(Heading6)`
    margin-top: 16px;
    margin-bottom: 16px;
    ${inheritBaseFont};
`;

export const CartEmptyBtnWrapper = styled.div`
    flex-direction: column;
    flex-wrap: wrap;
    order: 3;
    ${breakpoint('desktop')`
        justify-content: center;
        .elc-cart-page-checkout-btn-wrapper {
            max-width: 330px;
        }
    `};
`;

export const CartErrorsContent = styled(Body2)`
    text-align: justify;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    order: 0;
    ${inheritBaseFont};
`;

export const GoShoppingButton = styled(Button)`
    ${defaultCTA};
    ${inheritBaseFont};
`;

export const EmptyCartStyledFooter = styled(StyledFooter)`
    width: 100%;
`;
